import React from 'react';
import { Modal, ModalBody, Button, Form, ModalHeader } from 'reactstrap';
import * as EmployeeAction from 'store/actions/employee';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { fetchInvoiceNumber } from 'services/customDutyInvoice';
import BasicInfoForm from './../basicInfoForm';
import ItemInfoForm from './../itemInfoForm';
import AdressInputForm from 'pages/information/addressbook/inputForm';
import SelectWaybillDialog from './../selectWaybillDialog';
import './add-dialog.scss';
import { t } from 'i18next';
import { NotificationManager } from 'react-notifications';

export default function AddDialog({ modalOpen, onToggle, onSubmit, editData }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    control,
    getValues,
    watch,
  } = useForm({
    defaultValues: {
      basicinfo: {
        currency: 'MMK'
      },
      items: [
        {
          commodity: '',
          unit: '',
          qty: 1,
          import_licence_commodity_value_unit: 0,
          tax_amount_excl_tax: 0,
          doc_service_fee: 0,
          total_amount: 0,
          remark: '',
        },
      ],
    },
  });



  const submitData = async (values) => {
    if (editData) {
      values.isEdit =true;
    }
    onSubmit(values);
  };

  const [selectedAddress, setSelectedAddress] = React.useState(null);
  const [showWaybillDialog, setShowWaybillDialog] = React.useState(false);

  const dispatch = useDispatch();
  const countries = useSelector((state) => state.location.countries);

  React.useEffect(() => {
    if (editData) {
      setValue('basicinfo.invoice_no', editData?.invoice_number);
      setValue('basicinfo.license_no', editData?.license_no);
      setValue('basicinfo.waybill_number', editData?.waybill_number);
      setValue('basicinfo.invoice_date', editData?.invoice_date);
      setValue('basicinfo.currency', 'MMK'); // Always set to MMK
      setValue('basicinfo.remark', editData?.remark || '');
      setValue('basicinfo.destination',editData?.destination?._id)

      setValue('basicinfo.id_no', editData?.id_no);
      
      // Set items array if exists
      if (editData?.items && editData.items.length > 0) {
        setValue('items', editData.items);
      }

      setValue('senderinfo', editData.sender);
      setValue('senderinfo.code', editData.address_code);
     

      setValue('receiverinfo', editData.receiver);

     
      setSelectedAddress({branch:{name:editData?.destination?.name},marketing_person:{name:editData?.sale_person?.name}})
    } else {
      reset({
        basicinfo: {
          currency: 'MMK' // Set default currency to MMK
        },
        items: [
          {
            commodity: '',
            unit: '',
            qty: 1,
            import_licence_commodity_value_unit: 0,
            tax_amount_excl_tax: 0,
            doc_service_fee: 0,
            total_amount: 0,
            remark: '',
          },
        ],
      });
    }
  }, [editData, getValues, reset, setValue]);

  React.useEffect(() => {
    dispatch(EmployeeAction.getMarketingPerson());
  }, [dispatch, EmployeeAction.getMarketingPerson]);

  const onFetchInvoiceNumber = async () => {
    const response = await fetchInvoiceNumber();
    if (response) {
      setValue('generated_invoice_number', response);
      setValue('basicinfo.invoice_no', response.invoice_number);
    }
  };

  const handleSelectWaybill = (waybill) => {
    setValue('basicinfo.waybill_number', waybill.waybillnumber);
    setValue('basicinfo.license_no', waybill.license_number);
    
    // Fill sender information
    if (waybill.sender) {
      setValue('senderinfo', waybill.sender);
      setValue('senderinfo.code', waybill.address_code);
    }
    
    // Fill receiver information
    if (waybill.receiver) {
      setValue('receiverinfo', waybill.receiver);
    }
    
    // Set destination and sales person if available
    if (waybill.destination) {
      setValue('basicinfo.destination', waybill.destination._id);
    }

    
    // Update selected address for display
    setSelectedAddress({
      branch: { name: waybill.destination?.name },
      marketing_person: { name: waybill.sale_person?.name }
    });

    setValue("address_code", waybill.address_code)
    
    setShowWaybillDialog(false);
  };

  return (
    <Modal
      isOpen={modalOpen}
      size='lg'
      style={{
        maxWidth: '1400px',
        width: '80%',
        minWidth: 400,
      }}
      backdrop={true}
    >
      {editData && (
        <ModalHeader style={{ background: '#e9e9ef' }}>
          <div>
            <h3>Invoice Number : {editData.invoice_number}</h3>
          </div>
        </ModalHeader>
      )}
      <ModalBody
        style={{
          maxHeight: '85vh',
          overflowY: 'auto',
        }}
      >
        <Form onSubmit={handleSubmit(submitData)} className='order-modal'>
          <BasicInfoForm
            register={register}
            control={control}
            errors={errors}
            setValue={setValue}
            getValues={getValues}
            editData={editData}
            watch={watch}
            selectedAddress={selectedAddress}
            onFetchInvoiceNumber={onFetchInvoiceNumber}
            onSelectWaybill={() => setShowWaybillDialog(true)}
          />

          <div className='divider'></div>
          <AdressInputForm
            register={register}
            errors={errors}
            control={control}
            options={{ countries: countries }}
            editData={editData}
            addNew={false}
            setValue={setValue}
            types={['senderinfo', 'receiverinfo']}
            getValues={getValues}
            onSelectAddress={(address) => {
              setSelectedAddress(address);
            }}
            noCard={true}
          />
          <div className='divider'></div>
          <ItemInfoForm
            register={register}
            control={control}
            errors={errors}
            setValue={setValue}
            watch={watch}
            editData={editData}
            getValues={getValues}
          />
          <div className='custom-modal-footer'>
            <Button color='success' type='button' onClick={() => onToggle(!modalOpen)}>
              {t('cancel')}
            </Button>
            <Button color='primary' type='submit'>
              {t('submit')}
            </Button>
          </div>
        </Form>
      </ModalBody>

      {/* Waybill Selection Dialog */}
      <SelectWaybillDialog
        modalOpen={showWaybillDialog}
        onToggle={setShowWaybillDialog}
        onSelect={handleSelectWaybill}
      />
    </Modal>
  );
}
